/* Hero Link® rep links: herolink.com/?rep=r-123 (the QR on a trainer-rep's class slides, assets/hl-trainer.js) saves the
   rep on the cart, the same as picking them under "Did a Hero Link rep help you?" (assets/hl-rep-referral.js), so the order
   is credited through the usual referral review. A rep who isn't active or approved isn't saved: it's just the normal store. */
(function () {
  'use strict';
  var m = /[?&]rep=(r-\d+)/.exec(location.search); if (!m) return;
  var id = m[1];
  // take it out of the address, so a shared or reloaded page doesn't apply it again
  try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])rep=r-\d+&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
  fetch('/apps/hl-trainer/rep/list', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
    var rep = ((j && j.reps) || []).filter(function (x) { return x.id === id; })[0];
    if (!rep) return;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ attributes: { 'Hero Link rep': rep.name, _hl_rep: rep.id } }) }).then(function () {
      // pickers already on the page show it; ones drawn later read it from the cart
      document.querySelectorAll('[data-hl-ref]').forEach(function (root) {
        var picked = root.querySelector('[data-hl-ref-picked]'), box = root.querySelector('.hl-ref__box'), name = root.querySelector('[data-hl-ref-pickname]');
        root.setAttribute('data-rep', rep.id); root.setAttribute('data-rep-name', rep.name);
        if (picked && box && name) { name.textContent = rep.name; picked.hidden = false; box.hidden = true; }
      });
    });
  }).catch(function () {});
})();
